import React from "react";
import { LOGO } from "../../constants";
export default function Logo({ className = "" }) {
  return <img src={LOGO} alt="Logo" className={className} />;
}
